<template>
	<Layout>
		<div class="rwt-portfolio-area rn-section-gap">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<!-- Start 标题 -->
						<SectionTitle text-align="center" subtitle="Products Detail" title="产 品 详 细" data-aos="fade-up"
							data-aos-delay="60" :section-title-style=3 :bread-list="breadList"/>
						<!-- end 标题 -->
						

						<!-- start 主体内容  -->
						<Portfolio class="mt--20" column="col-lg-4 col-md-6 mt--30" />
						<!-- end 主体内容 -->
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
	import Layout from '../components/common/Layout'
	import SectionTitle from "../components/elements/sectionTitle/SectionTitle"
	import Portfolio from '../components/elements/portfolio/Portfolio'
	import Breadcrumb from '../components/elements/breadcrumb/Breadcrumb.vue'

	export default {
		name: 'EdgeProductDetail',
		components: {
			Layout,
			SectionTitle,
			Portfolio,
			Breadcrumb
		},
		data() {
			// 从store中获取分类面包屑路径，若不存在则使用默认路径
			const storedPath = this.$store.state.productBread.breadPath;
			const basePath = storedPath ? storedPath : [
				{ Label:'首页', Url:'/' },
				{ Label:'产品中心', Url:'/products/'+this.$store.state.productBread.categoryID }
			];
			return {
				breadList:[
					...basePath,
					{
						Label:this.$store.state.productBread.typeName,
						Url:'#'
					}
				]
			} /* end @return {type} */
		}, /* end data(){} */
		mounted() {
			// console.log('productDetail:'+this.$store.state.productBread.typeName);
		},
	}
</script>

<style lang="scss">
	.text {
		font-family: "宋体";
		font-size: 12px;
		line-height: 20px;
		color: #999999;
	}

	OL LI {
		MARGIN: 8px
	}

	#con {
		FONT-SIZE: 12px;
		/*margin: 0px auto; WIDTH: 720px*/
	}

	#tags {
		PADDING-RIGHT: 0px;
		PADDING-LEFT: 0px;
		PADDING-BOTTOM: 0px;
		MARGIN: 0px 0px 0px 10px;
		WIDTH: 400px;
		PADDING-TOP: 0px;
		HEIGHT: 23px
	}

	#tags LI {
		BACKGROUND: url(../assets/images/edge/Active/联系我们页/二维码/qcode.jpg) no-repeat left bottom;
		FLOAT: left;
		MARGIN-RIGHT: 1px;
		LIST-STYLE-TYPE: none;
		HEIGHT: 23px
	}

	#tags LI A {
		PADDING-RIGHT: 10px;
		PADDING-LEFT: 10px;
		BACKGROUND: url(../assets/images/edge/Active/关于我们页/公司介绍/edge-radius.png) no-repeat right bottom;
		FLOAT: left;
		PADDING-BOTTOM: 0px;
		COLOR: #999;
		LINE-HEIGHT: 23px;
		PADDING-TOP: 0px;
		HEIGHT: 23px;
		TEXT-DECORATION: none
	}

	#tags LI.emptyTag {
		BACKGROUND: none transparent scroll repeat 0% 0%;
		WIDTH: 4px
	}

	#tags LI.selectTag {
		BACKGROUND-POSITION: left top;
		MARGIN-BOTTOM: -2px;
		POSITION: relative;
		HEIGHT: 25px
	}

	#tags LI.selectTag A {
		BACKGROUND-POSITION: right top;
		COLOR: #000;
		LINE-HEIGHT: 25px;
		HEIGHT: 25px
	}

	#tagContent DIV.selectTag {
		DISPLAY: block
	}
</style>
